import React from 'react'
import EditButton from 'components/EditButton'

export default function PageEditButton ({ url }) {
  return (
    <div
      style={{
        position: 'absolute',
        right: '1em'
      }}
    >
      <EditButton
        size={EditButton.SIZE.SMALL}
        url={url}
      />
    </div>
  )
}
